import OpenAI from 'openai';
import { getApiConfig } from './api-config';

export async function generateSpeech(text: string): Promise<string> {
  const config = getApiConfig();
  
  if (!config.apiKey) {
    throw new Error('API key is missing');
  }

  const openai = new OpenAI({
    apiKey: config.apiKey,
    dangerouslyAllowBrowser: true
  });

  try {
    const mp3 = await openai.audio.speech.create({
      model: "tts-1",
      voice: "alloy",
      input: text,
    });

    const blob = new Blob([await mp3.arrayBuffer()], { type: 'audio/mpeg' });
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Error generating speech:', error);
    throw new Error('Failed to generate speech');
  }
}